import { render, staticRenderFns } from "./prepayment-account.vue?vue&type=template&id=2a80d813&scoped=true&"
import script from "./prepayment-account.vue?vue&type=script&lang=js&"
export * from "./prepayment-account.vue?vue&type=script&lang=js&"
import style0 from "./prepayment-account.vue?vue&type=style&index=0&id=2a80d813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80d813",
  null
  
)

export default component.exports